export const getSubscribers = (state: RootState) => state.subscribers

export const getSubscribersItems = (state: RootState) => getSubscribers(state)?.items

export const getSubscribersCount = (state: RootState) => getSubscribers(state).total ?? 0
